<template>
<!-- position: fixed;bottom: 0;background-color:#ffffff; -->
  <div style="bottom: 0rem;position: fixed;background-color:#ffffff;">
    <div class="Tab">
      <div class="b">
        <router-link to="/index" class="a">
          <div class="TabItem" to="/index">
            <div
              class="iconfont icon-home"
              style="font-size: 2.75rem; text-align: center"
            >
              <div class="TabImp">首页</div>
            </div>
          </div>
        </router-link>
        <router-link to="/services" class="a">
          <div class="TabItem" to="/services">
            <div
              class="iconfont icon-product"
              style="font-size: 2.75rem; text-align: center"
            >
              <div class="TabImp">产品与服务</div>
            </div>
          </div>
        </router-link>

        <router-link to="/contact" class="a"
          ><div class="TabItem" to="/contact">
            <div
              class="iconfont icon-contact"
              style="font-size: 2.75rem; text-align: center"
            >
              <div class="TabImp">联系我们</div>
            </div>
          </div></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
export default {
  name: 'Tabbar',
}
</script>

<style scoped>
/* 设置未选中样式 */
.b {
  display: flex;
  text-align: center;
}
.a {
  color: #333333;
}
.Tab {
  width: 46.875rem;
  height: 7rem;
  margin-top:1.25rem;
}
.TabItem {
  float: left;
  width: 15.625rem;
}
.TabImp {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 1.75rem;
  text-align: center;
  margin-top:10px;
}
.router-link-active {
  color: #0099da;
}
</style>
